module.exports = __webpack_public_path__ + "static/img/page-bg.7a19d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionnaire/page-bg.png
// module id = uM8K
// module chunks = 1